// Using example from Tailwind UI: https://tailwindui.com/components/application-ui/elements/dropdowns
import { Fragment } from 'react';
import { Menu, Transition } from '@headlessui/react';
import Image from 'next/image';
import { FaChevronDown, FaCrown, FaUser, FaUsers } from 'react-icons/fa';
import { BsFillPeopleFill } from 'react-icons/bs';

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export default function ClientDropdown({ clients: rawClients, current, onClick, includeAll = false }) {
  const clients = rawClients.sort((a, b) => {
    return a.name.localeCompare(b.name);
  });
  const clientName = rawClients.find(c => c.id == current )?.name || "Clients";
  return (
    <Menu as="div" className="relative inline-block text-left z-30">
      <div>
        <Menu.Button className={`inline-flex items-center flex-row font-BreezeButton gap-x-2 text-xs leading-tight px-4 py-2 ${current ? "bg-cyan-200" : "bg-cyan-400 hover:bg-cyan-300"} active:shadow-lg transition-colors duration-500 ease-in-out uppercase text-sp text-black rounded-full`}>
            
            { current ? 
                <>
                    <FaUser className="w-6 h-4" />
                    {(clientName.length >= 16) ? `${clientName.substring(0, 15)}...` : clientName}
                </>
                : <>
                    <FaUsers className="w-6 h-4" />
                    Clients
                </>
            }
            <FaChevronDown className="w-3" />
        </Menu.Button>
      </div>

      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="origin-top-right absolute left-0 mt-2 w-56 min-h-[2vh] max-h-[50vh] overflow-y-auto rounded-md shadow-lg bg-slate-800 ring-1 ring-black ring-opacity-5 focus:outline-none">
          <div className="py-1">
                <Menu.Item key={"unsorted"}>
                    {({ active }) => (
                        <button
                        onClick={() => onClick(null)}
                        className={`
                            ${active ? 'bg-gray-600 text-slate-100' : 'text-gray-100'}} 
                            block px-4 py-2 text-sm flex flex-row gap-x-2 items-center w-full
                        `}
                        >
                            <BsFillPeopleFill className="w-8 h-8" />
                            Everyone
                        </button>
                    )}
                </Menu.Item>
                {
                    clients.map((client, index) => {
                        if (!includeAll && client.isNonVideoClient) return;
                        return (
                            <Menu.Item key={index}>
                                {({ active }) => (
                                    <button
                                        onClick={() => onClick(client.id)}
                                        className={`
                                            ${classNames(
                                            `${client.id === "UCxlyTwuE1uuieLnl_tjBYVQ" ? `${active ? "bg-yellow-900" : "text-gray-100"}` : `${active ? 'bg-gray-600 text-slate-100' : 'text-gray-100'}`}`,
                                            'block px-4 py-2 text-sm'
                                            )} flex flex-row gap-x-2 items-center text-left w-full
                                        `}
                                    >
                                        <Image width="64" height="64" referrerPolicy="no-referrer" className="rounded-full w-8 h-8" alt={client.name} src={client.thumbnail.default.url} unoptimized />
                                        {
                                            client.id === "UCxlyTwuE1uuieLnl_tjBYVQ" ? (
                                                <span className="flex gap-x-2 items-center">
                                                Kooleyy <FaCrown className="w-4 text-yellow-300" />
                                                </span>
                                            ) : client.name
                                        }
                                    </button>
                                )}
                            </Menu.Item>
                        )
                    })
                }
          </div>
        </Menu.Items>
      </Transition>
    </Menu>
  )
}